export default __webpack_public_path__ + "media/images/mailer-new/heading/key-deleted-2e56f7d345a1a5218c91049644496d4d.png";